import { TableColumn } from 'react-data-table-component';

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
}

interface DataRow {
  eventName: string;
  sectionName: string;
  date: string;
  cpf: string;
  actions: string;
}

export const columns: TableColumn<DataRow>[] = [
  {
    name: 'Evento',
    selector: row => row.eventName,
    // width: '300px',
  },
  {
    name: 'Setor',
    selector: row => row.sectionName,
    // width: '300px',
  },
  {
    name: 'Data',
    selector: row => row.date,
    // width: '170px',
  },
  {
    name: 'CPF',
    selector: row => row.cpf,
    // width: '100px',
  },
  {
    name: 'Ações',
    selector: row => row.actions,
  },
];

// eslint-disable-next-line no-shadow
export enum FormInputName {
  eventId = 'eventId',
  sectionId = 'sectionId',
}

// eslint-disable-next-line no-shadow
export enum ChangeType {
  PRODUCT_NAME,
  PRODUCT_PRICE,
}
